import { AbstractModelSchema } from './abstract_model_schema.js';
export const externalAuthStrategySchema = {
    displayName: 'external session token',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        secretKey: {
            type: 'keyString',
            required: true,
        },
    },
};
//# sourceMappingURL=external_auth_strategy_schema.js.map